import { ProcessPartnerTypes } from './process-partner-types.enum';
import { Currency } from '../../shared/models/currency.models';
import { ICountry } from '../../shared/services/country.models';
import { IBankDetails, ICostCenter } from '../countries/countries.models';

export interface IProcessPartners extends IProcessPartnersRequest {
  id: number;
  /** Technical property used only in frontend side to identify much easier which pp were
   * selected to be assigned/unassigned.
   */
  isSelected: boolean;
  receiveNotification: boolean;
  locations: IProcessPartnerLocation[];
}
export interface IProcessPartnersRequest {
  name: string;
  supplierNumber: string;
  code: string;
  email: string | null;
  processPartnerType: string;
  hasTimeLimitRecovery: boolean;
  isOriginatedFromVDS: boolean;
  isSelected: boolean;
  receiveNotification: boolean;
  isActive?: boolean;
}

export interface IProcessPartnerAssignmentRequest {
  id: number;
  receiveNotification: boolean;
}

export interface ITimeLimitRecoveryResponse {
  timeLimitRecovery: number;
  countryIds: number[];
}

export interface ITimeLimitDamageResponse {
  timeLimitDamage: number;
  countryIds: number[];
}

export interface ITimeLimitDamageRequests {
  timeLimitDamage: number;
  countryIds: number[];
}

export interface ITimeLimitSettlementResponse {
  timeLimitSettlement: number;
  countryIds: number[];
}

export interface IProcessPartnersResponse {
  id: number;
  name: string;
  supplierNumber: string;
  code: string;
  type: string;
  isActive: boolean;
  isOriginatedFromVds: boolean;
  isNewLiabilityReportClaim: boolean;
  timeLimitRecoveryResponse: ITimeLimitRecoveryResponse[];
  paymentCustomerNumber: string;
  disableBordereauStage: boolean;
  globalDealerNumber: string;
  timeLimitSettlementResponse: ITimeLimitSettlementResponse[];
  timeLimitDamageResponse: ITimeLimitDamageResponse[];
  notify: boolean;
  email: string;
  claimSharingAgreements: IClaimSharingAgreement[];
  estimateRequired: boolean;
  tax: number;
  processLevelType: string;
  currency: string;
  bankDetails: IBankDetails;
  costCenter: ICostCenter;
  paymentTargetCountries: ICountry[];
}

export interface IProcessPartnerLocation {
  city: string;
  code: string;
  country: string;
  currency: string;
  id: number;
  locationType: string;
  name: string;
  postalCode: string;
  street: string;
}

export interface IPpAssignment {
  id: number;
  name: string;
  vdsCode: string;
  isActive: boolean;
  processPartnerType: string;
  supplierNumber: string;
}

export interface IClaimSharingAgreement {
  id: number;
  name: string;
  defaultSelected: boolean;
  sharings: ISharing[];
}
export interface ISharing {
  id: number;
  percentage: number;
  fromAmount: string;
  toAmount: string;
}

// Considering refactoring after claims models available
export interface ICreateProcessPartner {
  type: ProcessPartnerTypes;
  name: string;
  supplierNumber: string | null;
  isActive: boolean | null;
  isNewLiabilityReportClaim: boolean | null;
  timeLimitRecoveryRequest: ITimeLimitRecoveryResponse[];
  timeLimitDamageRequests?: ITimeLimitDamageRequests[];
  globalDealerNumber: string | null;
  paymentCustomerNumber: string | null;
  disableBordereauStage: boolean | null;
  timeLimitSettlementRequest: ITimeLimitSettlementResponse[];
  email: string | null;
  notify: boolean;
  claimSharingAgreements?: Partial<IClaimSharingAgreementRequest>[];
  estimateRequired: boolean | null;
  tax: number | null;
  processLevelType: string | null;
  currency: Currency | null;
  paymentTargetCountries: ICountry[];
}

export interface IClaimSharingAgreementRequest {
  id: number;
  defaultSelected: boolean;
}

export const mapProcessPartnerResponseToCreate = (
  response: IProcessPartnersResponse
): ICreateProcessPartner => {
  return {
    type: response.type as ProcessPartnerTypes,
    name: response.name,
    supplierNumber: response.supplierNumber ?? null,
    isActive: response.isActive ?? false,
    isNewLiabilityReportClaim: response.isNewLiabilityReportClaim ?? null,
    timeLimitRecoveryRequest: response.timeLimitRecoveryResponse ?? [],
    timeLimitDamageRequests: response.timeLimitDamageResponse ?? [],
    globalDealerNumber: response.globalDealerNumber ?? null,
    paymentCustomerNumber: response.paymentCustomerNumber ?? null,
    disableBordereauStage: response.disableBordereauStage ?? false,
    timeLimitSettlementRequest: response.timeLimitSettlementResponse ?? [],
    email: response.email ?? null,
    notify: response.notify ?? false,
    claimSharingAgreements: response.claimSharingAgreements,
    estimateRequired: response.estimateRequired ?? null,
    tax: response.tax ?? null,
    processLevelType: response.processLevelType ?? null,
    currency: (response.currency as Currency) ?? null,
    paymentTargetCountries: response.paymentTargetCountries ?? [],
  };
};
